import deCH from './clerk/de-CH.json';
import frCH from './clerk/fr-CH.json';
import enSU from './clerk/en-US.json';

const CLERK_LOCALIZATION_PATH = {
  'de-CH': deCH,
  'fr-CH': frCH,
  'en-US': enSU,
};

export default function getGlobalClerkIntlContent(locale) {
  try {
    return CLERK_LOCALIZATION_PATH[locale];
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(`Failed to load global intl content for locale ${locale}:`, error);
    return {};
  }
}
